const ArrivalResponseApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_OCEAN_URL}/aci-ocean/oceanarrival/cusres/get`,
  POST: `${process.env.REACT_APP_USER_ACI_OCEAN_URL}/aci-ocean/oceanarrival/cusres`
};

export default ArrivalResponseApiUrls;
